const studentTypeList = [
    { value: 1, text_en: 'Direct Admission', text_bn: 'সরাসরি ভর্তি' },
    { value: 2, text_en: 'Admission Application', text_bn: 'ভর্তির আবেদন' }
]
const religionList = [
    { value: 1, text_en: 'Muslim', text_bn: 'মুসলিম' },
    { value: 2, text_en: 'Hinduism', text_bn: 'হিন্দু' },
    { value: 3, text_en: 'Buddhism', text_bn: 'বৌদ্ধ' },
    { value: 4, text_en: 'Christianity', text_bn: 'খ্রিষ্টান' },
    { value: 5, text_en: 'Other', text_bn: 'অন্যান্য' }
]

const manpowerTypeList = [
    { value: 1, text_en: 'Teacher', text_bn: 'শিক্ষক' },
    { value: 2, text_en: 'Staff', text_bn: 'কর্মচারী' }
]

const caseStatusList = [
    { value: 1, text_en: 'Pending', text_bn: 'প্রক্রিয়াধীন' },
    { value: 2, text_en: 'Detention', text_bn: 'আটকাদেশ' },
    { value: 3, text_en: 'Pending in Guardian Case', text_bn: 'অভিভাবক মামলায় প্রক্রিয়াধীন' },
    { value: 4, text_en: 'Detention Order in Guardian Case', text_bn: 'অভিভাবক মামলায় আটকাদেশ' }
]
const tenureTimeList = [
    { value: 1, text_en: 'Under 6 Months', text_bn: '৬ মাসের নীচে' },
    { value: 2, text_en: '6 Months - 1 Year', text_bn: '৬ মাস - ১ বছর' },
    { value: 3, text_en: '1 Year - 2 Year', text_bn: '১ বছর - ২ বছর' },
    { value: 4, text_en: 'Above 2 Years', text_bn: '২ বছরের উর্দ্ধে' }
]
const monthList = [
    {
      value: 1,
      text_en: 'January',
      text_bn: 'জানুয়ারী'
    },
    {
      value: 2,
      text_en: 'February',
      text_bn: 'ফেব্রুয়ারী'
    },
    {
      value: 3,
      text_en: 'March',
      text_bn: 'মার্চ'
    },
    {
      value: 4,
      text_en: 'April',
      text_bn: 'এপ্রিল'
    },
    {
      value: 5,
      text_en: 'May',
      text_bn: 'মে'
    },
    {
      value: 6,
      text_en: 'June',
      text_bn: 'জুন'
    },
    {
      value: 7,
      text_en: 'July',
      text_bn: 'জুলাই'
    },
    {
      value: 8,
      text_en: 'August',
      text_bn: 'আগস্ট'
    },
    {
      value: 9,
      text_en: 'September',
      text_bn: 'সেপ্টেম্বর'
    },
    {
      value: 10,
      text_en: 'October',
      text_bn: 'অক্টোবর'
    },
    {
      value: 11,
      text_en: 'November',
      text_bn: 'নভেম্বর'
    },
    {
      value: 12,
      text_en: 'December',
      text_bn: 'ডিসেম্বর'
    }
  ]
export default {
    studentTypeList,
    religionList,
    manpowerTypeList,
    caseStatusList,
    tenureTimeList,
    monthList
}
